import React from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  message: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, action }) => (
  <div className="card text-center py-12">
    <Inbox className="h-10 w-10 text-secondary-500 mx-auto mb-4" aria-hidden />
    <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
    <p className="text-secondary-400 mb-6 max-w-md mx-auto">{message}</p>
    {action}
  </div>
);

export default EmptyState;
